import React, { useState, useEffect } from "react";
import styled from "styled-components";

const LanguageSelector = ({ i18n }) => {
  // Initialize language from localStorage or fallback to 'English'
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");
    return savedLanguage || "English";
  });

  // Initial setup - set language from localStorage when component mounts
  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      setSelectedLanguage(savedLanguage);
    }
  }, []);

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language);
    localStorage.setItem("selectedLanguage", language);
  };

  return (
    <LanguageContainer>
      <LanguageOption>
        <LanguageLabel onClick={() => handleLanguageChange("English")}>
          <span>English</span>
          <RadioInput
            type="radio"
            checked={selectedLanguage === "English"}
            onChange={() => handleLanguageChange("English")}
          />
        </LanguageLabel>
      </LanguageOption>

      <LanguageOption>
        <LanguageLabel onClick={() => handleLanguageChange("Hindi")}>
          <span>हिन्दी</span>
          <RadioInput
            type="radio"
            checked={selectedLanguage === "Hindi"}
            onChange={() => handleLanguageChange("Hindi")}
          />
        </LanguageLabel>
      </LanguageOption>
      <LanguageOption>
        <LanguageLabel onClick={() => handleLanguageChange("Marathi")}>
          <span>मराठी</span>
          <RadioInput
            type="radio"
            checked={selectedLanguage === "Marathi"}
            onChange={() => handleLanguageChange("Marathi")}
          />
        </LanguageLabel>
      </LanguageOption>
    </LanguageContainer>
  );
};

const LanguageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`;

const LanguageOption = styled.div`
  width: 100%;
  transition: background-color 0.2s ease;
  border-radius: 10px;

  &:hover {
    background-color: #2a2a2a;
  }
`;

const LanguageLabel = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  color: var(--color-text-tertiary);
  cursor: pointer;
  width: 100%;

  span {
    font-size: 18px;
  }
`;

const RadioInput = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: red;
`;

export default LanguageSelector;
